enum GAME_BOY_SOUND_TYPE {
  GameBoyLoad = 'GAME_BOY_LOAD',
  ZeldaIntro = 'ZELDA_INTRO',

  // Tetris
  TetrisMusic = 'TETRIS_MUSIC',
  MoveSide = 'MOVE_SIDE',
  RotateShape = 'ROTATE_SHAPE',
  ShapeFall = 'SHAPE_FALL',
  LineClear = 'LineClear',
  TetrisPause = 'TetrisPause',
  TetrisGameOver = 'TetrisGameOver',
  TetrisGameOverFinal = 'TetrisGameOverFinal',

  // Space Invaders
  PlayerShoot = 'PLAYER_SHOOT',
  EnemyKilled = 'ENEMY_KILLED',
  PlayerKilled = 'PLAYER_KILLED',
}

export { GAME_BOY_SOUND_TYPE };
